// Clinic Configuration for Todays Dental @ Saluda Pointe
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Todays Dental @ Saluda Pointe",
  clinicId: "dentistatsaludapointe",
  clinicUrl: "https://dentistatsaludapointe.com",
  // Contact Information
  phoneNumber: "(803) 399-8236",
  phoneNumberRaw: "+18033998236", // For tel: and sms: links
  email: "dentalcare@dentistatsaludapointe.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistatsaludapointe&agentId=e4012f32-81ce-439b-ac91-a562ba680956",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistatsaludapointe/voice",

  // Location
  address: "105 Saluda Pointe Ct Suite C, Lexington, SC 29072, United States",
  addressShort: "105 Saluda Pointe Ct Suite C, Lexington, SC 29072",
  city: "LEXINGTON",
  hcity: 'Lexington',
  state: "South Carolina",
  stateShortForm: "SC",
  PostalCode: "29072",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/sTSKyKmQPRVRck846",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d80613.17173689576!2d-81.151339!3d34.012896!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f8a2b2b7fc9bd1%3A0x5ced2c933dfb4344!2sDentist%20at%20Saluda%20Pointe!5e1!3m2!1sen!2sin!4v1759832145320!5m2!1sen!2sin',
  iframeTitle: "Todays Dental @ Saluda Pointe",

  //membership
  membership: 'https://member.kleer.com/?slug=MT7H',

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalatSaludaPointe",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/todays-dental-at-saluda-pointe?utm_source=practice&utm_medium=email&m=56758",


  // Analytics
  gaMeasurementId: "G-3TF18WDSRZ",
  clarityProjectId: "prcqs5tiew",

  // Google Ads — direct conversion tracking
  googleAdsId: "AW-10876354140",
  googleAdsConversions: {
    // Primary — used for Smart Bidding optimization
    "phone_call_click": "AW-10876354140/O-i4CO_Ww5QcENz8n8Io",
    "contact_form_success": "AW-10876354140/UxgaCPSet4YcENz8n8Io",
    "call_back_success": "AW-10876354140/HMvlCMuot4YcENz8n8Io",
    "chatbot_phone_click": "AW-10876354140/jDqRCIHut5QcENz8n8Io",
    "chatbot_voice_call": "AW-10876354140/mWKdCNPYw5QcENz8n8Io",
    "book_appointment_success": "AW-10876354140/P_h5COy5roYcENz8n8Io",
    "Confirm-Booking": "AW-10876354140/a-xGCLHaw5QcENz8n8Io",
    "Submit-Payment": "AW-10876354140/CgxtCMeDzZQcENz8n8Io",
    // Secondary — observation/reporting only
    "sms_click": "AW-10876354140/h9AnCJnut5QcENz8n8Io",
    "directions_click": "AW-10876354140/PIgxCJzaw5QcENz8n8Io",
    "email_click": "AW-10876354140/TMbzCJ_aw5QcENz8n8Io",
    "map_click": "AW-10876354140/QbGJCNSEzZQcENz8n8Io",
    "social_media_click": "AW-10876354140/zC-2CN2EzZQcENz8n8Io",
    "financing_click": "AW-10876354140/8ByFCJ3vt5QcENz8n8Io",
    "membership_click": "AW-10876354140/qVoCCIbwt5QcENz8n8Io",
    "outbound_link_click": "AW-10876354140/2nxlCOOEzZQcENz8n8Io",
    "chat_send": "AW-10876354140/_kcPCOaEzZQcENz8n8Io",
    "chatbot_quick_action": "AW-10876354140/NQW1CM_aw5QcENz8n8Io",
    "chatbot_insurance_upload": "AW-10876354140/pnUyCPDxt5QcENz8n8Io",
  } as Record<string, string>,

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistatsaludapointe",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistatsaludapointe",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistatsaludapointe",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistatsaludapointe.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistAtSaludaPointe",
    instagram: "https://www.instagram.com/dentistatsaludapointe/",
    twitter: "https://x.com/DA_SaludaPointe",
    linkedin: "https://www.linkedin.com/company/108121738/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.facebook.com/DentistAtSaludaPointe",
  },
  reviewLinks: {
    google: "https://business.google.com/n/16907736124982154551/profile?hl=en-GB&fid=6696057231881487172",
    facebook: "https://www.facebook.com/DentistAtSaludaPointe/",
    yelp: "https://www.yelp.com/biz/dentist-at-saluda-pointe-lexington",
  },
  // Open Dental Configuration
  defaultProvNum: 11,
  defaultOpNum: 14,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 12,
      AppointmentTypeNum: 13
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 14,
      AppointmentTypeNum: 18
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 14,
      AppointmentTypeNum: 1
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "18035252269",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
